package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.Serializable

@Serializable
actual data class DeleteRequest (
    actual var ids: List<String> = emptyList(),
    actual var currentUser: String? = null,
    actual var requestPage: Int? = null,
)